const prod = 'https://byteapp.herokuapp.com';
// const local = 'http://localhost:8000';
const url = prod;

export const fetchBoards = () => {
  return (dispatch, getState) => {
    let headers = {'Content-Type': 'application/json'};
    let {token} = getState().auth;

    if (token) {
      headers['Authorization'] = `Token ${token}`;
    }

    return fetch(url+`/api/boards/`, {headers, })
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log('Server Error!');
        }
      })
      .then(res => {
        if (res.status === 200) {
          return dispatch({type: 'FETCH_BOARDS', boards: res.data});
        } else if (res.status === 401 || res.status === 403) {
          dispatch({type: 'AUTHENTICATION_ERROR', data: res.data});
          throw res.data;
        }
      })
  }
}

export const resetBoards = () => {
  return (dispatch, getState) => {
    dispatch({type: 'RESET_BOARDS'});
  }
}

export const createBoard = title => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    let headers = {'Content-Type': 'application/json'};
    

    if (token) {
      headers['Authorization'] = `Token ${token}`;
    }

    let body = JSON.stringify({title});

    return fetch(url+`/api/boards/`, {headers, body, method: 'POST'})
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
              return {status: res.status, data};
          })
        } else {
          console.log('Server Error!');
          throw res;
        }
      })
      .then(res => {
        if (res.status === 201) {
          return dispatch({type: 'CREATE_BOARD', board: res.data});
        } else if (res.status === 401 || res.status === 403) {
          dispatch({type: 'AUTHENTICATION_ERROR', data: res.data});
          throw res.data;
        }
      })
  }
}

export const editBoard = (boardId, title) => {
  return (dispatch, getState) => {
    
    const {token} = getState().auth;
    let headers = {'Content-Type': 'application/json'};

    if (token) {
      headers['Authorization'] = `Token ${token}`;
    }

    let body = JSON.stringify({title});

    return fetch(url+`/api/boards/${boardId}/`, {headers, method: 'PUT', body})
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log('Server Error!');
          throw res;
        }
      })
      .then(res => {
        if (res.status === 200) {
          return dispatch({type: 'EDIT_BOARD', board: res.data, boardId});
        } else if (res.status === 401 || res.status === 403) {
          dispatch({type: 'AUTHENTICATION_ERROR', data: res.data});
          throw res.data;
        }
      })
  }
}

export const updateBoard = (index, selectedApp) => {
  return (dispatch, getState) => {
    
    const {token} = getState().auth;
    let headers = {'Content-Type': 'application/json'};

    if (token) {
      headers['Authorization'] = `Token ${token}`;
    }

    let apps = getState().boards[index].apps;
    apps.push(selectedApp);

    let title = getState().boards[index].title;
    let body = JSON.stringify({ title, apps, });
    let boardId = getState().boards[index].id;

    return fetch(url+`/api/boards/${boardId}/`, {headers, method: 'PUT', body})
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log('Server Error!');
          throw res;
        }
      })
      .then(res => {
        if (res.status === 200) {
          return dispatch({type: 'UPDATE_BOARD', board: res.data, index});
        } else if (res.status === 401 || res.status === 403) {
          dispatch({type: 'AUTHENTICATION_ERROR', data: res.data});
          throw res.data;
        }
      })
  }
}

export const deleteBoard = boardId => {
  return (dispatch, getState) => {

    const {token} = getState().auth;
    let headers = {'Content-Type': 'application/json'};

    if (token) {
      headers['Authorization'] = `Token ${token}`;
    }

    return fetch(url+`/api/boards/${boardId}`, {headers, method: 'DELETE'})
      .then(res => {
        if (res.status === 204) {
          return {status: res.status, data: {}};
        } else if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log('Server Error!');
          throw res;
        }
      })
      .then(res => {
        if (res.status === 204) {
          return dispatch({type: 'DELETE_BOARD', boardId}).then(window.location.reload());
        } else if (res.status === 401 || res.status === 403) {
          dispatch({type: 'AUTHENTICATION_ERROR', data: res.data});
          throw res.data;
        }
      })
  }
}


// WEBPACK FOOTER //
// ./src/actions/boards.js